import { Component } from '@angular/core';

@Component({
	templateUrl: './notfound-page.component.html',
})
export class NotFoundPageComponent {}
